import type { PaymentMethodCode, ServiceCode } from "types/ManagerPayment";

export const PAYMENT_METHOD_COLOR: Record<PaymentMethodCode, string> = {
  CONFIRMED_CARD: "#1F6AFF",
  KIOSK: "#0FA3B1",
  MANUAL_CARD: "#5B8DEF",
  BPAY: "#4E23A8",
  TRANSFER: "#2E7A9F",
  CASH: "#03921A",
};
export const REFUND_COLOR = "#FD4235";

export const SERVICE_COLOR: Record<ServiceCode, string> = {
  PLACE: "#2F8F46",
  APPOINTMENT: "#E8792E",
  CLASS: "#7A4FD1",
  OPTION: "#D1367A",
  ETC: "#8A91A0",
  TRANSFER_COMMISSION: "#C9A227",
};
